import { round } from '../math';

export function getFormattedValue({ messageFormatter, capabilityObj, value }) {
  const emptyChar = '-';

  if (value == null) return emptyChar;

  switch (capabilityObj.type) {
    case 'boolean':
      if (capabilityObj.titleTrue != null && capabilityObj.titleFalse != null) {
        return value === true ? capabilityObj.titleTrue : capabilityObj.titleFalse;
      }

      return messageFormatter(`common.${value}`);
    case 'number':
      if (capabilityObj.units) {
        if (capabilityObj.units === '%') {
          // todo handle case where someone decides to use
          // min -1 and max 1 for whatever reason

          if (capabilityObj.max === 1 && capabilityObj.min === 0) {
            value = capabilityObj.value * 100;
          }

          return `${round(value, capabilityObj.decimals)}${capabilityObj.units}`;
        }

        return `${round(value, capabilityObj.decimals)} ${capabilityObj.units}`;
      }

      return value;
    case 'string':
      return value.toString();
    case 'enum':
      const id = value.toString();
      const enumValue = capabilityObj.values?.find((value) => {
        return value.id === id;
      });
      return enumValue?.title ?? emptyChar;
    default:
      return null;
  }
}

export const capabilityUtils = {
  getFormattedValue,
};
